<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
      @if (service()) {
        <ion-button (click)="delete()">
          <ion-icon
            name="trash-outline"
            slot="icon-only"
            size="small"
          ></ion-icon>
        </ion-button>
      }
    </ion-buttons>
    <ion-title>Lektion</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!this.serviceForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="serviceForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="document-text-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input formControlName="name" placeholder="Bezeichnung"></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item-divider>
        <ion-label>Übersicht</ion-label>
      </ion-item-divider>
      <ion-item lines="full" joyrideStep="service-category" (next)="disableInput.set(true)" (back)="disableInput.set(false)" (done)="disableInput.set(false)" title="Kategorie" text="Wähle die Kategorie für diese Lektion aus. Die Kategorie bestimmt, welcher Ausbildungsplan für die Lektion verwendet wird.">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="car-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-select
          label="Kategorie"
          aria-label="Kategorie"
          formControlName="category"
          value="B"
          okText="Festlegen"
          cancelText="Abbrechen"
        >
          <ion-select-option value="A">A</ion-select-option>
          <ion-select-option value="-A">-A</ion-select-option>
          <ion-select-option value="A1">A1</ion-select-option>
          <ion-select-option value="B">B</ion-select-option>
          <ion-select-option value="BE">BE</ion-select-option>
          <ion-select-option value="B1">B1</ion-select-option>
          <ion-select-option value="C">C</ion-select-option>
          <ion-select-option value="CE">CE</ion-select-option>
          <ion-select-option value="C1">C1</ion-select-option>
          <ion-select-option value="C1E">C1E</ion-select-option>
          <ion-select-option value="D">D</ion-select-option>
          <ion-select-option value="DE">DE</ion-select-option>
          <ion-select-option value="D1">D1</ion-select-option>
          <ion-select-option value="D1E">D1E</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5" joyrideStep="service-price-duration" (next)="disableInput.set(false)" (back)="disableInput.set(false)" (done)="disableInput.set(false)" title="Preis und Dauer" text="Wie lange dauert eine Lektion bei dir? Und wie viel kostet sie? Hier kannst du den Preis und die Dauer für deine Lektion festlegen. Es ist auch möglich, für die gleiche Kategorie verschiedene Lektionen mit unterschiedlichen Preisen und Dauern festzulegen (z.B. eine vergünstigte Probe-Lektion).">
      <ion-item-divider>
        <ion-label>Preis und Dauer</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="cash-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="CHF "
          type="number"
          formControlName="prize"
          placeholder="Preis"
          [readonly]="disableInput()"
        ></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon color="primary" name="time-outline" class="text-lg -mt-1"></ion-icon>
        </ion-note>
        <ion-input
          label="Min "
          formControlName="duration"
          type="number"
          placeholder="Dauer"
          [readonly]="disableInput()"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item-divider>
        <ion-label>Abo</ion-label>
      </ion-item-divider>
      <ion-item lines="full" joyrideStep="service-subscription" (back)="disableInput.set(true)" (done)="disableInput.set(false)" title="Abo" text="Falls du Abos anbietest, kannst du hier angeben, ob diese Lektion mit einem Abo bezahlt werden kann.">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="help-circle-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-toggle formControlName="subscription">
          <ion-label>Abo-Zahlung möglich</ion-label>
          <ion-note color="medium" class="text-xs">Kann mit Lektionen aus Abos bezahlt werden</ion-note>
        </ion-toggle>
      </ion-item>
    </ion-list>
  </form>
</ion-content>